<template>
  <div>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    <div class="text-left" style="padding-top:0%; padding-bottom: 80px; overflow-y: auto;" :style="viewStyle">
      <!-- Tabs -->
      <v-row class="ma-0 pt-2" style="padding-left: 20px; background:#FFF; position: sticky; top: 0; z-index: 3; border-bottom: 1px solid #EEE;">
        <v-tabs v-model="tab" color="#ED6D00" background-color="transparent">
          <v-tabs-slider color="#ED6D00"></v-tabs-slider>
          <v-tab>{{$t('__profile')}}</v-tab>
          <v-tab>{{$t('__resetPassword')}}</v-tab>
        </v-tabs>
      </v-row>

      <!-- Content Box -->
      <div id="box" style="margin-top:3%">
        <!-- Profile Tab -->
        <div v-if="tab === 0">
          <v-row class="pb-5">
            <v-icon class="ma-0 pa-0 primary-color" size="28">mdi-menu-right</v-icon>
            <h4 class="primary-color" style="padding-top:2px">{{$t('__profile')}}</h4>
          </v-row>

          <v-form ref="profileForm" v-model="profileValid" lazy-validation>
            <v-row class="mx-2">
              <!-- Left Column -->
              <v-col class="pa-0 col-12 col-md-6">
                <v-row class="ma-0">
                  <v-col class="px-0 col-2 col-md-4">
                    <div class="text-right pt-2 pt14">{{$t('__company')}}</div>
                  </v-col>
                  <v-col class="col-10 col-md-8">
                    <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.company"></v-text-field>
                  </v-col>
                </v-row>

                <v-row class="ma-0">
                  <v-col class="px-0 col-2 col-md-4">
                    <div class="text-right pt14" style="padding-top:10px">{{$t('__nation')}}</div>
                  </v-col>
                  <v-col class="col-10 col-md-8">
                    <v-select class="border pt14" dense readonly background-color="#F4F8F9" outlined :items="nationList" v-model="datasets.nation"></v-select>
                  </v-col>
                </v-row>

                <v-row class="ma-0">
                  <v-col class="px-0 col-2 col-md-4">
                    <div class="text-right pt-2 pt14"><span class="start">*</span>{{$t('__staffName')}}</div>
                  </v-col>
                  <v-col class="col-10 col-md-8">
                    <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.name"></v-text-field>
                  </v-col>
                </v-row>

                <v-row class="ma-0">
                  <v-col class="px-0 col-2 col-md-4">
                    <div class="text-right pt-2 pt14">{{$t('__title')}}</div>
                  </v-col>
                  <v-col class="col-10 col-md-8">
                    <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.title"></v-text-field>
                  </v-col>
                </v-row>

                <v-row class="ma-0">
                  <v-col class="px-0 col-2 col-md-4">
                    <div class="text-right pt-2 pt14">{{$t('__tel')}}</div>
                  </v-col>
                  <v-col class="col-10 col-md-8">
                    <v-text-field class="text_field" dense background-color="white" outlined v-model="datasets.phone"></v-text-field>
                  </v-col>
                </v-row>
              </v-col>

              <!-- Right Column -->
              <v-col class="pa-0 col-12 col-md-6">
                <v-row class="ma-0">
                  <v-col class="px-0 col-2 col-md-4">
                    <div class="text-right pt-2 pt14">{{$t('__group')}}</div>
                  </v-col>
                  <v-col class="col-10 col-md-8">
                    <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.group"></v-text-field>
                  </v-col>
                </v-row>

                <v-row class="ma-0">
                  <v-col class="px-0 col-2 col-md-4">
                    <div class="text-right pt-2 pt14">{{$t('__division')}}</div>
                  </v-col>
                  <v-col class="col-10 col-md-8">
                    <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.division"></v-text-field>
                  </v-col>
                </v-row>

                <v-row class="ma-0">
                  <v-col class="px-0 col-2 col-md-4">
                    <div class="text-right pt-2 pt14"><span class="start">*</span>{{$t('__empId')}}</div>
                  </v-col>
                  <v-col class="col-10 col-md-8">
                    <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.employeeId"></v-text-field>
                  </v-col>
                </v-row>

                <v-row class="ma-0">
                  <v-col class="px-0 col-2 col-md-4">
                    <div class="text-right pt-2 pt14">{{$t('__mobile')}}</div>
                  </v-col>
                  <v-col class="col-10 col-md-8">
                    <v-text-field class="text_field" dense background-color="white" outlined v-model="datasets.mobile"></v-text-field>
                  </v-col>
                </v-row>
              </v-col>

              <!-- Full Width Rows -->
              <v-col cols="12" class="pa-0">
                <v-row class="ma-0">
                  <v-col class="px-0 col-2 col-md-2" style="max-width: 16.66% !important; flex: 0 0 16.66% !important;">
                    <div class="text-right pt-2 pt14">{{$t('__address')}}</div>
                  </v-col>
                  <v-col class="col-10 col-md-10">
                    <v-text-field class="text_field" dense background-color="white" outlined v-model="datasets.address"></v-text-field>
                  </v-col>
                </v-row>

                <v-row class="ma-0">
                  <v-col class="px-0 col-2 col-md-2" style="max-width: 16.66% !important; flex: 0 0 16.66% !important;">
                    <div class="text-right pt-2 pt14"><span class="start">*</span>{{$t('__email')}}</div>
                  </v-col>
                  <v-col class="col-10 col-md-10">
                    <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.account" :rules="emailRules"></v-text-field>
                  </v-col>
                </v-row>
              </v-col>

            </v-row>
          </v-form>
        </div>

        <!-- Reset Password Tab -->
        <div v-if="tab === 1">
          <v-row class="pb-5">
            <v-icon class="ma-0 pa-0 primary-color" size="28">mdi-menu-right</v-icon>
            <h4 class="primary-color" style="padding-top:2px">{{ $t('__resetPassword') }}</h4>
          </v-row>

          <v-form ref="passwordForm" v-model="passwordValid" lazy-validation>
            <!-- ID & Name Row -->
            <v-row class="mx-2">
              <v-col class="pa-0 col-12 col-md-6">
                <v-row class="ma-0">
                  <v-col class="px-0 col-2 col-md-4">
                    <div class="text-right pt-2 pt14"><span class="start">*</span>{{$t('__staffName')}}</div>
                  </v-col>
                  <v-col class="col-10 col-md-8">
                    <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.name"></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
              <v-col class="pa-0 col-12 col-md-6">
                <v-row class="ma-0">
                  <v-col class="px-0 col-2 col-md-4">
                    <div class="text-right pt-2 pt14"><span class="start">*</span>{{$t('__empId')}}</div>
                  </v-col>
                  <v-col class="col-10 col-md-8">
                    <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.employeeId"></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <!-- Old Password (full width) -->
            <v-row class="mx-2">
              <v-col cols="12" class="pa-0">
                <v-row class="ma-0">
                  <v-col class="px-0 col-2 col-md-2" style="max-width: 16.66% !important; flex: 0 0 16.66% !important;">
                    <div class="text-right pt-2 pt14"><span class="start">*</span>{{$t('__oldPassword')}}</div>
                  </v-col>
                  <v-col class="col-10 col-md-10">
                    <v-text-field class="text_field" dense outlined 
                      :placeholder="$t('__pleaseInputOldPassword')"
                      :type="showOld ? 'text' : 'password'"
                      :append-icon="showOld ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="showOld = !showOld"
                      v-model="oldPassword"></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <!-- New Password (full width) -->
            <v-row class="mx-2">
              <v-col cols="12" class="pa-0">
                <v-row class="ma-0">
                  <v-col class="px-0 col-2 col-md-2" style="max-width: 16.66% !important; flex: 0 0 16.66% !important;">
                    <div class="text-right pt-2 pt14"><span class="start">*</span>{{$t('__newPassword')}}</div>
                  </v-col>
                  <v-col class="col-10 col-md-10">
                    <v-text-field class="text_field" dense outlined
                      :placeholder="$t('__passwordHint')"
                      :type="showNew ? 'text' : 'password'"
                      :append-icon="showNew ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="showNew = !showNew"
                      v-model="newPassword"></v-text-field>
                  </v-col>
                </v-row>
                <!-- Password validation rules -->
                <v-row class="ma-0">
                  <v-col class="px-0 col-2 col-md-2" style="max-width: 16.66% !important; flex: 0 0 16.66% !important;"></v-col>
                  <v-col class="col-10 col-md-10 pt-0">
                    <div class="validation-list" style="display: flex; flex-direction: column; gap: 4px;">
                      <div v-for="(rule, index) in passwordRules" :key="index" class="d-flex align-center">
                        <v-icon x-small :color="rule.valid ? '#4CAF50' : '#9E9E9E'" class="mr-1">
                          {{ rule.valid ? 'mdi-check-circle' : 'mdi-circle-outline' }}
                        </v-icon>
                        <span :style="{ color: rule.valid ? '#4CAF50' : '#9E9E9E', fontSize: '12px' }">{{ rule.text }}</span>
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <!-- Confirm Password (full width) -->
            <v-row class="mx-2">
              <v-col cols="12" class="pa-0">
                <v-row class="ma-0">
                  <v-col class="px-0 col-2 col-md-2" style="max-width: 16.66% !important; flex: 0 0 16.66% !important;">
                    <div class="text-right pt-2 pt14"><span class="start">*</span>{{$t('__confirmPassword')}}</div>
                  </v-col>
                  <v-col class="col-10 col-md-10">
                    <v-text-field class="text_field" dense outlined
                      :placeholder="$t('__pleaseConfirmPassword')"
                      :type="showConfirm ? 'text' : 'password'"
                      :append-icon="showConfirm ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="showConfirm = !showConfirm"
                      v-model="confirmPassword"></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-form>
        </div>
      </div>
    </div>

    <!-- Bottom Buttons -->
    <v-footer id="footer" class="fixed-footer">
      <div class="text-center mx-auto footer">
        <v-btn class="btn" large color="#979491" style="color: #FFF; box-shadow:none" @click="back()">{{$t('__cancel')}}</v-btn>
        <v-btn class="btn" large color="#ED6D00" style="color: #FFF; box-shadow:none" @click="save()">{{$t('__confirm')}}</v-btn>
      </div>
    </v-footer>

    <ShowMsg ref="ShowMsg" />
  </div>
</template>

<script>
import i18n from '@/plugins/i18n'
import ShowMsg from '@/dialogs/ShowMsg'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.min.css'
import { resetPassword } from '@/api/account'

export default {
  name: 'EditProfile',
  components: {ShowMsg, Loading},
  data: () => ({
    isLoading: false,
    tab: 0,
    viewStyle: {},
    profileValid: true,
    passwordValid: true,
    datasets: {
      id: 0,
      employeeId: '',
      account: '',
      password: '',
      name: '',
      nation: 'HK',
      title: '',
      phone: '',
      mobile: '',
      permission: '',
      permissionName: '',
      division: '',
      group: '',
      onDutyDate: '',
      status: '',
      company: '',
      function: '',
      address: '',
    },
    nationList: ['HK', 'TW', 'CN', 'SG'],
    emailRules: [],
    // Reset Password State
    oldPassword: '',
    newPassword: '',
    confirmPassword: '',
    showOld: false,
    showNew: false,
    showConfirm: false,
    newPasswordRules: [
      v => !!v || i18n.t('__newPassword') + ' is required',
      v => /^(?=.*[a-zA-Z])(?=.*\d).+$/.test(v) || i18n.t('__passwordHint')
    ],
    requiredField:['name','account','employeeId',],
  }),
  computed: {
    passwordRules() {
      return [
        { text: i18n.t('__passUpper'), valid: /[A-Z]/.test(this.newPassword) },
        { text: i18n.t('__passLower'), valid: /[a-z]/.test(this.newPassword) },
        { text: i18n.t('__passNumber'), valid: /[0-9]/.test(this.newPassword) },
        { text: i18n.t('__passLength'), valid: this.newPassword.length >= 12 && this.newPassword.length <= 20 }
      ]
    },
    confirmPasswordRules() {
      return [
        v => !!v || i18n.t('__confirmPassword') + ' is required',
        v => v === this.newPassword || i18n.t('__passNotMatch')
      ]
    }
  },
  mounted() {
    this.fetchData()
  },
  created() {
    this.calculateWindows()
    this.$root.$on('windowInnerHeight', () => {
      this.calculateWindows()
    })
  },
  methods: {
    calculateWindows() {
      this.viewStyle = {height: window.innerHeight - 135 + 'px'}
    },
    fetchData() {
      this.isLoading = true
      const id = sessionStorage.getItem('loginAccount')
      var self = this
      this.$http.get('/SingleEmployee', { params: { account: id } })
        .then(res => {
          const data = res.data.Data || res.data.data || res.data
          self.datasets = Object.assign({}, self.datasets, data)
          // Use some mapping if function field contains JSON with name
          if (data.functionName) {
            self.datasets.functionName = data.functionName
          } else if (data.function) {
            // If function is just a string display it
            self.datasets.functionName = data.function
          }
        })
        .catch(err => {
          console.error(err)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    back() {
      this.$router.back()
    },
    save() {
      if (this.tab === 0) {
        this.saveProfile()
      } else {
        this.savePassword()
      }
    },
    saveProfile() {
      if (!this.$refs.profileForm.validate()) return

      if(!this.$Global.checkForm(this.datasets,this.requiredField)){
        this.$refs.ShowMsg.open(1)
        return
      }

      this.isLoading = true
      var self = this

      const payload = {
        id: this.datasets.id,
        employeeId: this.datasets.employeeId,
        account: this.datasets.account,
        name: this.datasets.name,
        nation: this.datasets.nation,
        title: this.datasets.title,
        phone: this.datasets.phone,
        mobile: this.datasets.mobile,
        division: this.datasets.division,
        address: this.datasets.address,
        group: this.datasets.group,
        onDutyDate: this.datasets.onDutyDate,
        status: this.datasets.status,
        company: this.datasets.company,
        function: this.datasets.function
      }

      this.$http.post('/UpdateEmployee', payload, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(res => {
          self.$refs.ShowMsg.open(0, i18n.t('__savedSuccessfully'), res.data.Message, false)
        })
        .catch(err => {
          self.$refs.ShowMsg.open(0, i18n.t('__savedError'), err.response?.data?.Message || 'Save failed')
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    async savePassword() {
      if (!this.$refs.passwordForm.validate()) return
      
      const allRulesValid = this.passwordRules.every(r => r.valid)
      if (!allRulesValid) {
        this.$refs.ShowMsg.open(1)
        return
      }

      if (this.newPassword !== this.confirmPassword) {
        this.$refs.ShowMsg.open(0, this.$t('__systemHint'), this.$t('__passwordNotMatch'))
        return
      }

      this.isLoading = true
      try {
        const account = sessionStorage.getItem('loginAccount') || this.datasets.account || this.datasets.employeeId
        const res = await resetPassword(account, this.oldPassword, this.newPassword)
        this.$refs.ShowMsg.open(0, i18n.t('__savedSuccessfully'), res.Message || res.data?.Message, false)
        this.oldPassword = ''
        this.newPassword = ''
        this.confirmPassword = ''
      } catch (err) {
        this.$refs.ShowMsg.open(0, this.$t('__systemHint'), err.response?.data?.ErrorMessage || 'Reset password failed')
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>

<style scoped>
  .fixed-footer {
    position: fixed !important;
    bottom: 0 !important;
    left: 0 !important;
    right: 0 !important;
    background: white !important;
    z-index: 10 !important;
    box-shadow: 0px -4px 4px 0px rgba(0, 0, 0, 0.06) !important;
    padding: 13.5px 0px !important;
  }

  .primary-color {
    color: #ED6D00;
  }

  .pt14 {
    font-size: 14px;
    color: #666;
  }

  .start {
    color: red !important;
    margin-right: 2px;
  }
</style>
